import { gql, 
  useQuery 
} from "@apollo/client";
import { 
  CashFlowOverviewAdminQueryQuery, 
  CashFlowOverviewAdminQueryQueryVariables 
} from "../../../../../schemaTypes";

export const cashFlowOverviewAdminQuery = gql`
  query CashFlowOverviewAdminQuery($duration: String!) {
    cashFlowOverviewAdmin(duration: $duration) {
      totalPlatformBalance
      totalTransactionVolume
      successfulTransactionVolume
      pendingTransactionVolume
      failedTransactionVolume
      totalTransactionValue
      totalWithdrawn
      commissionEarned
    }
  }
`;

interface Props {
  variables: CashFlowOverviewAdminQueryQueryVariables;
  children: (data: CashFlowOverviewAdminQueryQuery) => React.ReactElement | null;
}


export const CashFlowOverviewAdminController: React.FC<Props> = ({ children, variables }) => {
  const { data } = useQuery<
    CashFlowOverviewAdminQueryQuery,
    CashFlowOverviewAdminQueryQueryVariables
  >(cashFlowOverviewAdminQuery, {
    variables,
    notifyOnNetworkStatusChange: true,
  });

  return children(
    data as CashFlowOverviewAdminQueryQuery
  );
};